import { createAction } from 'redux-actions';
import get from 'lodash/get';

import { CONSTANTS, ROUTES } from 'enum';
import { extractResponseErrorStatus, createResponseErrorMessage } from 'utils/responseErrorHandler';
import { createCustomer } from 'api/rest';
import { logout } from 'api/auth';
import { REGISTER_CONTRACT_ID, SET_CONTRACT_ID_ERROR, CLEAR_CONTRACT_ID_ERROR } from './actionTypes';
import history from '../../history';
import { startLoading, finishLoading, setError } from '../user/actions';
import { loginSuccess, clearData, logoutUser } from '../auth/actions';
import { removeCurrentCustomer, setCurrentCustomer, setCustomers } from '../customers/actions';

export const setContractIdError = createAction(SET_CONTRACT_ID_ERROR);
export const clearContractIdError = createAction(CLEAR_CONTRACT_ID_ERROR);

const customerSelector = (state) => get(state, ['auth', 'customers']);
const currentCustomer = (state) => get(state, ['customers', 'currentCustomer']);

const finishRegistrationProcedure = async ({ customer, dispatch, getState }) => {
  const customers = customerSelector(getState());

  if (customers && customers.length) {
    await logout();
    dispatch(removeCurrentCustomer());
    dispatch(logoutUser());
    dispatch(setError('Please login again to access your new organization'));
    dispatch(clearData());
    history.replace(ROUTES.LOGIN);
  } else {
    const accessToken = localStorage.getItem(CONSTANTS.LOCAL_ACCESS_TOKEN_KEY);
    dispatch(setCustomers([customer]));
    dispatch(setCurrentCustomer(customer));
    dispatch(loginSuccess({ accessToken }));
    history.replace({
      pathname: `${ROUTES.CUSTOMERS}/${customer.uuid}`,
      state: { openEcosystemDialog: true },
    });
  }
};

export const registerCustomerWithContractId = (companyData) => async (dispatch, getState) => {
  dispatch({ type: REGISTER_CONTRACT_ID, payload: companyData });
  const curCustomer = currentCustomer(getState());

  dispatch(startLoading());
  dispatch(setContractIdError());

  try {
    const payload = {
      ...curCustomer,
      ...companyData,
    };

    if (curCustomer.contact) {
      payload.contact = curCustomer.contact;
    }

    const { data: customer } = await createCustomer(payload);
    await finishRegistrationProcedure({ customer, dispatch, getState });
  } catch (error) {
    if (error.response && error.response.data.message) {
      dispatch(setContractIdError(error.response.data.message));
    } else {
      const { field } = error;
      const errorStatus = extractResponseErrorStatus(error);
      const errorMessage = field
        ? `Invalid Data Passed As "${field}"`
        : createResponseErrorMessage({
            specificErrorHandler: {
              default: 'Error while parsing your Contract ID',
            },
            status: errorStatus,
          });
      dispatch(setContractIdError(errorMessage));
    }
  } finally {
    dispatch(finishLoading());
  }
};
